import { TrackingState } from 'gwi-tracker';
import CONFIG from './config';

class BrickData {

  constructor(params, api) {
    this.api = api;

    this.brickId = params.brickId;
    this.watchableId = params.watchableId || params.watchable_id;
    this.watchableType = params.watchableType || params.watchable_type;
    this.posterUrl = params.posterUrl || params.poster_url;
    this.year = params.year;

    if (params.numberOfQueues !== undefined) {
      this.numberOfQueues = params.numberOfQueues;
    } else if (params.number_of_queues !== undefined) {
      this.numberOfQueues = params.number_of_queues;
    }

    if (params.watchUrl && params.watchUrl.match(/^\//)) {
      this.watchUrl = CONFIG.websiteUrl + params.watchUrl;
    } else {
      this.watchUrl = params.watchUrl;
    }

    this.title = params.title;
    this.annotation = params.annotation;

    if (params.inQueue !== undefined) {
      this.inQueue = params.inQueue;
    } else if (params.in_queue !== undefined) {
      this.inQueue = params.in_queue;
    }

    if (params.numberOfRatings !== undefined) {
      this.numberOfRatings = params.numberOfRatings;
    } else if (params.number_of_ratings !== undefined) {
      this.numberOfRatings = params.number_of_ratings;
    }

    this.isLoggedIn = params.isLoggedIn || params.is_logged_in;
    this.userLists = params.userLists || params.user_lists;
    this.trailerUrl = params.trailerUrl || params.trailer_url;
    this.rating = params.rating;
    this.hideUserActions = params.hideUserActions || params.hide_user_actions;
    this.externalLink = params.externalLink || params.external_link;
    this.isModalBrick = params.isModalBrick || params.is_mobile_brick;

    this.isMobile = params.isMobile;
    if (typeof params.isMobile === 'string') {
      this.isMobile = params.isMobile === 'true';
    }

    this.fireBrickImpression = params.fireBrickImpression;
    if (typeof params.fireBrickImpression === 'string') {
      this.fireBrickImpression = params.fireBrickImpression === 'true';
    }

    this.mainCallToAction = 'How To Watch';
    this.userRating = null;

    this.listId = params.listId;
    this.listItemId = params.listItemId;
    this.categoryId = params.categoryId;
    this.campaign = params.campaign;

    this.listItemContextType = params.listItemContextType;
    this.listItemContextId = params.listItemContextId;

    this.defaultTrackingOptions = params.defaultTrackingOptions || {};

    this.inWidget = params.inWidget;

    this.trackingState = this.trackingState || new TrackingState(
            this.watchableType,
            this.watchableId,
            this.getTrackingStateOptions(),
        );
  }

  updateFromLoginResponse(response) {
    this.userRating = response.user_rating;
    this.isLoggedIn = response.logged_in;
    this.inQueue = response.in_queue;
  }

  getTrackingStateOptions() {
    return {
      defaultTrackingOptions: this.defaultTrackingOptions,

      brickId: this.brickId,
      campaign: this.campaign,
      inWidget: this.inWidget,
      medium: this.medium,
      mediumContext: this.mediumContext,
      categoryId: this.categoryId,

      listId: this.listId,
      listItemId: this.listItemId,
      listItemContextType: this.listItemContextType,
      listItemContextId: this.listItemContextId,
    };
  }

  static fromQueryParams(params, api) {
    return new BrickData(params, api);
  }

  static isValid(params) {
    if ('posterUrl' in params
      && 'year' in params
      && 'numberOfQueues' in params
      && 'watchUrl' in params
      && 'title' in params
      && 'annotation' in params
      && 'numberOfRatings' in params
      && 'trailerUrl' in params
      && 'rating' in params
    ) {
      return true;
    }

    return false;
  }

  static fromApiResponse(response, api, queryParams = {}) {
    const brick = response.bricks[0];

    const apiParameters = {
      watchableType: brick.resource_type,
      watchableId: brick.resource_id,
      numberOfQueues: brick.queue_count,
      watchUrl: brick.url,
      isLoggedIn: brick.logged_in,
    };

    const queryParameters = {
      hideUserActions: queryParams.hideUserActions,
      externalLink: queryParams.externalLink,
      isMobile: queryParams.isMobile,
      isModalBrick: queryParams.isModalBrick,
      listId: queryParams.listId,
      listItemId: queryParams.listItemId,
      listItemContextType: queryParams.listItemContextType,
      listItemContextId: queryParams.listItemContextId,
      categoryId: queryParams.categoryId,
      campaign: queryParams.campaign,
      defaultTrackingOptions: queryParams.defaultTrackingOptions,
      trackBrickImpression: queryParams.trackBrickImpression,
      brickId: queryParams.brickId,
      inWidget: queryParams.inWidget,
    };

    const parameters = { ...brick, ...apiParameters, ...queryParameters };

    return new BrickData(parameters, api);
  }
}

export default BrickData;



// WEBPACK FOOTER //
// ./src/shared/helpers/brick-data.js